import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { BufferedSourceJsonReader1eguw7qhrwt7p as BufferedSourceJsonReader } from './BufferedSourceJsonReader.mjs';
import { MapJsonReader2b7ri7r44421y as MapJsonReader } from './MapJsonReader.mjs';
import {
  toIntExactOrNull6ky18km1ou13 as toIntExactOrNull,
  toIntExactOrNull2t2wdfvexswy6 as toIntExactOrNull_0,
  toLongExactOrNull3c5zyitei28os as toLongExactOrNull,
} from './internal/Utils.mjs';
import { Token_LONG_getInstance1ss7l3se79ypx as Token_LONG_getInstance } from './JsonReader.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readAny(_this__u8e3s4) {
  var token = _this__u8e3s4.peek_21nx7_k$();
  var tmp;
  switch (token.ordinal_1) {
    case 9:
      tmp = _this__u8e3s4.nextNull_njy9ei_k$();
      break;
    case 8:
      tmp = _this__u8e3s4.nextBoolean_nfdk1h_k$();
      break;
    case 7:
    case 6:
      tmp = guessNumber(_this__u8e3s4);
      break;
    case 5:
      tmp = _this__u8e3s4.nextString_kwkc9o_k$();
      break;
    case 2:
      _this__u8e3s4.beginObject_5wddq0_k$();
      // Inline function 'kotlin.collections.mutableMapOf' call

      var result = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
      while (_this__u8e3s4.hasNext_bitz1p_k$()) {
        result.put_4fpzoq_k$(_this__u8e3s4.nextName_njxula_k$(), readAny(_this__u8e3s4));
      }

      _this__u8e3s4.endObject_ofuv3u_k$();
      tmp = result;
      break;
    case 0:
      _this__u8e3s4.beginArray_hxn19s_k$();
      // Inline function 'kotlin.collections.mutableListOf' call

      var result_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      while (_this__u8e3s4.hasNext_bitz1p_k$()) {
        result_0.add_utx5q5_k$(readAny(_this__u8e3s4));
      }

      _this__u8e3s4.endArray_s2tmpq_k$();
      tmp = result_0;
      break;
    default:
      // Inline function 'kotlin.error' call

      var message = 'unknown token ' + token.toString();
      throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
  }
  return tmp;
}
function guessNumber(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof MapJsonReader()) {
    tmp = _this__u8e3s4.nextGuessedNumber_kuqb75_k$();
  } else {
    if (_this__u8e3s4 instanceof BufferedSourceJsonReader()) {
      tmp = guessNumberNoThrow(_this__u8e3s4);
    } else {
      tmp = guessNumberOrThrow(_this__u8e3s4);
    }
  }
  return tmp;
}
function guessNumberNoThrow(_this__u8e3s4) {
  if (_this__u8e3s4.peek_21nx7_k$().equals(Token_LONG_getInstance())) {
    var asLong = _this__u8e3s4.nextLong_njwv0v_k$();
    var tmp0_elvis_lhs = toIntExactOrNull(asLong);
    return tmp0_elvis_lhs == null ? asLong : tmp0_elvis_lhs;
  }
  var tmp;
  try {
    tmp = _this__u8e3s4.nextDouble_s2xvfg_k$();
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3 = $p;
      return _this__u8e3s4.nextNumber_n9bzz8_k$();
    } else {
      throw $p;
    }
  }
  var asDouble = tmp;
  var tmp1_elvis_lhs = toIntExactOrNull_0(asDouble);
  var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? toLongExactOrNull(asDouble) : tmp1_elvis_lhs;
  return tmp2_elvis_lhs == null ? asDouble : tmp2_elvis_lhs;
}
function guessNumberOrThrow(_this__u8e3s4) {
  try {
    return _this__u8e3s4.nextInt_ujorgc_k$();
  } catch ($p) {
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3 = $p;
    } else {
      throw $p;
    }
  }
  try {
    return _this__u8e3s4.nextLong_njwv0v_k$();
  } catch ($p_0) {
    if ($p_0 instanceof Exception()) {
      var _unused_var__etf5q3_0 = $p_0;
    } else {
      throw $p_0;
    }
  }
  try {
    return _this__u8e3s4.nextDouble_s2xvfg_k$();
  } catch ($p_1) {
    if ($p_1 instanceof Exception()) {
      var _unused_var__etf5q3_1 = $p_1;
    } else {
      throw $p_1;
    }
  }
  return _this__u8e3s4.nextNumber_n9bzz8_k$();
}
function jsonReader(_this__u8e3s4) {
  return new (BufferedSourceJsonReader())(_this__u8e3s4);
}
function jsonReader_0(_this__u8e3s4) {
  return new (MapJsonReader())(_this__u8e3s4);
}
//region block: exports
export {
  jsonReader as jsonReaderkr2c3w0efm9b,
  jsonReader_0 as jsonReader2agwreccj3lmk,
  readAny as readAny17j2jqaxubdko,
};
//endregion

//# sourceMappingURL=JsonReaders.mjs.map
